import {CopilotSidePanelContent} from '@github-ui/copilot-chat-side-panel/CopilotSidePanelContent'
import {memo} from 'react'

export const SIDEBAR_MIN_WIDTH = 450
export const SIDEBAR_MAX_WIDTH = 768
export const SIDEBAR_WIDTH_CONSTRAINTS = {
  min: `${SIDEBAR_MIN_WIDTH}px`,
  default: '544px',
  max: `${SIDEBAR_MAX_WIDTH}px`,
} as const

/**
 * Inner content for the copilot side panel sidebar.
 * Must be rendered inside a SplitPageLayout.Sidebar to be detected by Primer's slot system.
 */
export const CopilotSidePanelSidebarContent = memo(function CopilotSidePanelSidebarContentImpl() {
  return (
    <div className="height-full">
      <CopilotSidePanelContent />
    </div>
  )
})
